module.exports = __webpack_public_path__ + "static/img/naniungo-slide-16.3020e2fa.jpg";